<template>
    <div class="modal-print" :style="print">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">合同预览</div>
            </div>
            <div class="modal-body"  :style="bodyStyle">
                <template>
                     <div>
                        <iframe :src="path" id="mobsf" :style="bodyStyle" class="iframes"></iframe>
                    </div>
                </template>
            </div>
            <div class="modal-footer">
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div>
        </div>
    </div>
</template>

<script>

     import {timeStr} from "@/common/times";
     import {hex_md5} from "@/common/Base64MD5";
     import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'ExportInfo',
        data() {
            return {
                loading: false,
                applyTypeValue:['80-99周岁','100周岁及以上'],
                idCardImgDialog: false,
                idCardImgBackDialog: false,
                accountBookImgDialog: false,
                accountBookImgBackDialog: false,
                recentImgDialog: false,
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                print:'',
                path:'',
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.bodyStyle = "height:"+(val+50)+'px';
            },
        },
        methods: {
            init(elderlyCode,printClassName){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ElderlyFile/FilePreview",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyCode:elderlyCode,
                        printName:printClassName
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            let path = this.$imgUrl+response.data.data.path;
                            var appNav=document.getElementsByClassName('app-nav');
                            this.goodslist="left:"+appNav[0].scrollWidth+'px'
                            this.path='https://view.officeapps.live.com/op/view.aspx?src='+path
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
                
            },
            closeSelf() {
                this.loading = false;
                this.$emit("closeExportInfo");
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-print {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .iframes{
                width:100%;
                border: 0;
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-upload--picture {
                display: inline;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 20px;
                color: #8c939d;
                width: 180px;
                height: 180px;
                line-height: 180px;
                text-align: center;
            }
            .modal-body  /deep/ .el-upload--picture-card{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .modal-body  .avatarImg{
                width:100%;
                height: 180px;
                line-height: 180px;
            }
            .modal-body {
                position: relative;
                padding: 0  0 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 500px;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 35%;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
